module.exports = __webpack_public_path__ + "img/gl.ba08dffb.svg";